
import { useState } from "react";
import { MembershipForm } from "./adhesion/MembershipForm";
import { MembershipOptions } from "./adhesion/MembershipOptions";
import { HeroSection } from "./adhesion/HeroSection";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { HandHeart, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";

export default function Adhesion() {
  const [showMembershipForm, setShowMembershipForm] = useState(false);
  const [selectedMembershipType, setSelectedMembershipType] = useState<"active" | "benefactor" | "donor" | null>(null);
  const [donationAmount, setDonationAmount] = useState<number>(0);

  const handleSelectMembershipType = (type: "active" | "benefactor" | "donor") => {
    setSelectedMembershipType(type);
    
    // Seulement afficher le formulaire et déclencher le défilement 
    // si ce n'est pas le type "donor" (pour permettre de modifier le montant)
    if (type !== "donor") {
      setShowMembershipForm(true);
      
      setTimeout(() => {
        document.getElementById("membership-form")?.scrollIntoView({ 
          behavior: "smooth", 
          block: "start" 
        });
      }, 100);
    } else {
      // Pour "donor", juste mettre à jour le type sans déclencher le défilement
      setShowMembershipForm(true);
    }
  };

  const heroContent = {
    title: "Rejoignez-nous !",
    description: "Soutenons les principes de Liberté, Egalité, Fraternité et Laïcité tout comme les valeurs fondamentales de la République française que sont la Solidarite, le Respect des droits de l'égalité devant la loi telles qu'elles sont fondées par la Déclaration des droits de l'Homme du du citoyen.",
    backgroundImage: "/lovable-uploads/7bd7eb79-3cf9-47b3-803d-49b683133dcb.png"
  };

  return (
    <div className="min-h-screen">
      <Seo title="Devenir membre | Enfants de la République" description="Adhérez à l'association Enfants de la République ou devenez bénévole pour transmettre et défendre les valeurs de la République." path="/adhesion" />
      <Header />
      <div className="min-h-screen bg-gradient-to-b from-[#FFFD4C] via-[#FFFD4C] to-[#F5E84A] pt-24">
        <HeroSection 
          title={heroContent.title}
          description={heroContent.description}
          backgroundImage={heroContent.backgroundImage}
          rightSlot={
            <Link
              to="/benevolat"
              className="group flex flex-col items-center justify-center text-center w-full sm:w-40 sm:aspect-square bg-white p-3 rounded-xl shadow-md hover:shadow-lg transition-all border-2 border-transparent hover:border-blue-900"
            >
              <div className="p-2 rounded-lg bg-blue-900/10 text-blue-900 mb-1">
                <HandHeart className="w-6 h-6" />
              </div>
              <h3 className="text-sm font-bold text-blue-900 leading-tight">Devenir Bénévole</h3>
              <p className="text-[11px] text-blue-900/80 mt-1">
                Rejoignez-nous et participez activement à nos actions.
              </p>
              <ArrowRight className="w-4 h-4 text-blue-900 mt-1 group-hover:translate-x-1 transition-transform" />
            </Link>
          }
        />

        <div className="container max-w-5xl pt-0 pb-2">
          {/* Show membership options immediately */}
          <div id="membership-options" className="mb-6 transition-all duration-500 animate-fadeIn">
            <MembershipOptions 
              onSelectType={handleSelectMembershipType} 
              donationAmount={donationAmount}
              setDonationAmount={setDonationAmount}
              selectedType={selectedMembershipType}
            />
          </div>
          
          {showMembershipForm && (
            <div id="membership-form" className="mt-6 transition-all duration-500 animate-fadeIn">
              <MembershipForm 
                initialMembershipType={selectedMembershipType as "active" | "benefactor" | "donor"} 
                donationAmount={selectedMembershipType === "donor" ? donationAmount : undefined}
              />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
